import React, { FC } from 'react';
import {
  Circle,
  Flex,
  TabProps,
  Text,
  useStyleConfig,
  useTab,
} from '@chakra-ui/react';

const CustomTab: FC<TabProps> = React.forwardRef((props, ref) => {
  const tabProps = useTab(props);
  const isSelected = !!tabProps['aria-selected'];

  const styles = useStyleConfig('Tab');

  return (
    <Flex
      mx={[3, 6, 10]}
      sx={styles}
      direction='column'
      alignItems='center'
      _hover={{
        cursor: 'pointer',
      }}
      {...tabProps}
    >
      <Text
        mb={2}
        fontWeight='600'
        fontSize={['md', 'lg']}
        color={isSelected ? 'white' : 'gray.400'}
      >
        {tabProps.children}
      </Text>
      <Circle size='2' bg={isSelected ? 'cyan.400' : 'gray.400'} />
    </Flex>
  );
});

export default CustomTab;
